export default __webpack_public_path__ + "static/media/SlideOne.50679063.png";